module.exports = __webpack_public_path__ + "img/jointop.31ab5a68.png";